import CurrentQR from "Components/CurrentQR";
import MyBrand from "Components/MyBrand";
import IStyle from "Interfaces/IStyle";
import React from "react";
import { Col, Figure, Row } from "react-bootstrap";
// import { KoFiWidget } from 'react-kofi';
import { Link } from "react-router-dom";

const styles: IStyle = {
	pipe: {
		marginLeft: "0.6em",
		marginRight: "0.6em",
		// fontSize: "1.2em"
	},
	icon: {
		marginLeft: "0.2em",
		marginRight: "0.2em",
		width:"1.5em",
	}
}

interface IProps {
	hideBrand?: boolean;
}

export default function MyBrandFooter(props: IProps) {
	return (<Row style={{marginTop: 10}}>
		<Col>
			{ !!props.hideBrand && <Row><Col><MyBrand /></Col></Row>}
			<Row style={{textAlign: "center", marginTop: "0.2em"}}>
				<Col className="web-footer">
					{/* <small> */}
						<span>
							<Link target="_blank" to="https://discord.gg/rnDfMg2Xhg">
								<Figure.Image alt="Discord" style={styles.icon} src="https://www.google.com/s2/favicons?sz=64&domain=discord.com"></Figure.Image>
								midokuni
							</Link>
						</span>
						<span className="text-pink" style={styles.pipe}>●</span>
						<span>
							<Link target="_blank" to="https://bsky.app/profile/midokuni.com">
								<Figure.Image alt="Blue Sky" style={styles.icon} src="https://www.google.com/s2/favicons?sz=64&domain=bsky.app"></Figure.Image>
								@midokuni.com
							</Link>
						</span>
						<span className="text-pink" style={styles.pipe}>●</span>
						<span>
							<Link target="_blank" to="https://x.com/Midokuni_Mido">
								<Figure.Image alt="X (Formerly Twitter)" style={styles.icon} src="https://www.google.com/s2/favicons?sz=64&domain=x.com"></Figure.Image>
								@Midokuni_Mido
							</Link>
						</span>
						<span className="text-pink" style={styles.pipe}>●</span>
						<span>
						{/* <KoFiDialog
							color="#00b4f7"
							textColor="#fff"
							id="prototypr"
							label="Support me"
							padding={0}
							width={400}
							iframe={false}
							buttonRadius="8px"
							/> */}
{/* 
							<KoFiWidget
							attachOnScroll={false}
							id="midokuni"
							label="Feed me"
							color="rgba(255, 175, 255, 0.3)"
							// color="#00b9fe"
							textColor="rgb(255, 175, 255);"
							// textColor="var(--pink);"
							// textColor="#fff"
							/> */}
							<Figure.Image alt="Ko-Fi" style={styles.icon} src="https://www.google.com/s2/favicons?sz=64&domain=ko-fi.com"></Figure.Image>
							Feed me <Link target="_blank" to="https://ko-fi.com/midokuni">Ko-fi</Link>
							</span>
						<span className="text-pink" style={styles.pipe}>●</span>
							<Figure.Image alt="Ko-Fi" style={styles.icon} src="https://www.google.com/s2/favicons?sz=64&domain=patreon.com"></Figure.Image>
						<span>
							Give me a Head <Link target="_blank" to="https://www.patreon.com/c/Midokuni?utm_medium=unknown&utm_source=hina.loves.midokuni&utm_campaign=creatorshare_creator"><strong>Pat</strong>reon</Link>
						</span>
					{/* </small> */}
				</Col>	
			</Row>
			<Row style={{textAlign: "center", marginTop: "0.2em"}}>
				<Col>
					<CurrentQR />
				</Col>
			</Row>
			<Row style={{textAlign: "center", marginTop: "0.1em"}}>
				<Col>
					<sub>
						I am related to neither Nexon, Yostar nor any of their affiliates. I am just a simple fan doing this as a hobby.
					</sub>
				</Col>	
			</Row>
		</Col>	
	</Row>
)
}